import { render, staticRenderFns } from "./ShareButtons.vue?vue&type=template&id=445ea968"
import script from "./ShareButtons.vue?vue&type=script&lang=js"
export * from "./ShareButtons.vue?vue&type=script&lang=js"
import style0 from "./ShareButtons.vue?vue&type=style&index=0&id=445ea968&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports